import BModal from "./BModal";

export default class BModalTrigger
{
	constructor(el)
	{
		this.el = el;
	}

	static initialize()
	{
		document.querySelectorAll(`[data-modal-selector]`).forEach(el => {
			const modalTrigger = new this(el);
		});

		this.addEventListeners();
		this.openFromHash();
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			if (event.target.matches(`[data-modal-selector], [data-modal-selector] *`)) {
				event.preventDefault();
				(new this(event.target.closest(`[data-modal-selector]`))).getModal().open();
				return;
			}

			const trigger = event.target.closest(`.modal-trigger[href^="#"]`);
			if (trigger) {
				event.preventDefault();
				const selector = trigger.getAttribute("href");
				const modalEl = document.querySelector(selector);
				if (modalEl) {
					(new BModal(modalEl)).open();
				}
			}
		});

		window.addEventListener("hashchange", () => this.openFromHash());
	}

	static openFromHash()
	{
		const hash = window.location.hash;
		if (!hash) {
			return;
		}

		const modalEl = document.querySelector(hash + `.modal`);
		if (modalEl) {
			(new BModal(modalEl)).open();
		}
	}

	getModal()
	{
		return new BModal(document.querySelector(this.el.dataset.modalSelector));
	}
}
